// This file is automatically generated from ingestAssets.mjs
import * as React from 'react';
import IconContainer, { IconProps } from '../../../components/IconContainer';

export function EyeClosedIcon(props: IconProps) {
	return (
		<IconContainer {...props}>
			{
				<svg
					xmlns="http://www.w3.org/2000/svg"
					width="100%"
					height="100%"
					fill="none"
					viewBox="0 0 32 32"
				>
					<path
						fill="currentColor"
						d="M28.5 21.875a1.001 1.001 0 0 1-1.365-.375l-2.375-4.15a15.404 15.404 0 0 1-4.51 2.082l.734 4.403a.998.998 0 0 1-.823 1.151 1 1 0 0 1-1.146-.823l-.721-4.322a16.637 16.637 0 0 1-4.585 0l-.721 4.323a1 1 0 1 1-1.975-.329l.737-4.402a15.405 15.405 0 0 1-4.507-2.087L4.875 21.5a1.004 1.004 0 1 1-1.742-1l2.5-4.375a19.18 19.18 0 0 1-2.413-2.5 1 1 0 1 1 1.558-1.25C6.853 14.943 10.483 18 16 18c5.518 0 9.148-3.061 11.223-5.625a.998.998 0 0 1 1.706.106 1 1 0 0 1-.151 1.144 19.182 19.182 0 0 1-2.413 2.5l2.5 4.375a.999.999 0 0 1-.365 1.375Z"
					/>
				</svg>
			}
		</IconContainer>
	);
}
